import {
  ExportTypes,
  ExportJobTypes,
  ExportTransportTypes,
  ReportNames,
  ExportType,
} from 'constants/exportTypes';
import { Resources } from 'constants/resources';

import { useState } from 'react';

import { useReportExport } from 'hooks/queries/useReportExport';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useListController, useNotify } from 'react-admin';
import { Order } from 'types/embedded/order';
import { cleanEmpty } from 'utils/cleanEmpty';

type Props = {
  onSuccess: () => void;
};

export function useOrdersReportExport({ onSuccess }: Props) {
  const translate = useTypedTranslate();

  const { filterValues } = useListController<Order>({
    resource: Resources.Orders,
    queryOptions: { enabled: false },
  });

  const [isSendReportOnEmail, setIsSendReportOnEmail] = useState(false);
  const [exportType, setExportType] = useState<ExportType>(ExportTypes.Excel);
  const notify = useNotify();

  const matchRejectReason = filterValues?.matchRejectReason
    ? Boolean(Number(filterValues.matchRejectReason))
    : null;

  const { mutate: exportMutate, isLoading: isExportLoading } = useReportExport({
    filters: cleanEmpty({
      ...filterValues,
      orderExternalErrorReason: matchRejectReason ? filterValues?.orderExternalErrorReason : null,
      orderProviderExternalError: !matchRejectReason
        ? {
            reason: filterValues?.orderProviderExternalError?.providerExternalError?.reason,
          }
        : null,
      exportType: exportType,
      jobType: ExportJobTypes.Orders,
      notificationTransport: isSendReportOnEmail ? [ExportTransportTypes.Email] : null,
    }),
    preferenceKey: ReportNames.Orders,
    onSuccess: () => {
      notify(
        `${translate('app.orders.ordersExportFileIs')} ${isSendReportOnEmail ? translate('app.orders.ordersExportFileIsSend') : ''}`,
        {
          type: 'info',
        },
      );
      onSuccess();
    },
    onError: (error) => {
      notify(error.data?.errors[0]?.title, { type: 'error' });
    },
  });

  return {
    exportMutate,
    isExportLoading,
    exportType,
    setExportType,
    setIsSendReportOnEmail,
    isSendReportOnEmail,
  };
}
